import { faCode, faTimeline, faUmbrellaBeach, faUser } from "@fortawesome/free-solid-svg-icons";
import AppLink from "components/common/AppLink";
import Page from "components/common/page/Page";
import TabNav from "components/common/tabs/TabNav";
import TabNavLink from "components/common/tabs/TabNavLink";
import Translate from "components/common/Translate";
import { AppRoutes } from "config/router";
import { Outlet, useLocation } from "react-router-dom";
import UISettings from "./ui/UISettings";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

type SettingsPagePropsType = {
}

const SettingsPage = (props: SettingsPagePropsType) => {
    const location = useLocation();
    const context = useAppContext();

    const settingsSection = [
        {
            title: 'pages.season.list',
            name: 'season',
            icon: faTimeline,
            path: AppRoutes.SEASON_HOME
        },
        {
            title: 'pages.users.list',
            name: 'user',
            icon: faUser,
            path: AppRoutes.USER_HOME,
            role: Roles.ADMIN
        }, 
        {
            title: 'pages.accommodation.main',
            name: 'accommodation',
            icon: faUmbrellaBeach,
            path: AppRoutes.ACCOMMODATION_ROOM_AND_TYPE_SETTINGS,
            role: Roles.ADMIN
        },
        {
            title: 'Api token',
            name: 'api-token',
            icon: faCode,
            path: AppRoutes.API_TOKEN,
            role: Roles.ADMIN
        }
    ]

    const getLinks = () => {
        const lis = settingsSection.filter(x => !x.role || context.userHasRole(x.role)).map((section, index) => {
            return (
                <li className="pt-2 text-lg" key={section.name}>
                    <AppLink to={section.path}>
                        <Translate i18nKey={section.title} />
                    </AppLink>
                </li>
            )
        });

        return (
            <Page title="pages.settings.main">
                <div>
                    <ul className="list-disc p-4">
                        {lis}
                    </ul>
                </div>
                <div>
                    <UISettings />
                </div>
            </Page>
        );
    }

    const getTabs = () => {
        const tabs = settingsSection.map((section, index) => {
            return (
                <TabNavLink key={section.name} to={section.path} icon={section.icon} text={section.title} />
            );
        });

        return (
            <div className="app-tabs">
                <TabNav>
                    {tabs}
                </TabNav>
                <Outlet />
            </div>
        )
    };

    return location.pathname.toLowerCase() === '/app/settings' ? getLinks() : getTabs();
};

export default SettingsPage;
